/* eslint-disable */
"use strict";
import errorService from "@/services/errorService";
import { fetchTO } from "@/components/helpers";
// const service = process.env.VUE_APP_service_magazzino || '' // usato solo per installazione su Windows 32bit (senza IIS con reverse proxy)
var config, service, serviceAnalisi, serviceInventario;
(async () => {
  const response = await fetch(process.env.BASE_URL + "config.json");
  config = await response.json();
  service = config.service_magazzino || process.env.VUE_APP_service_magazzino;
  serviceInventario =
    config.service_inventario || process.env.VUE_APP_service_magazzino;
  serviceAnalisi =
    config.service_analisi || process.env.VUE_APP_service_magazzino;
})();

async function cicleSync(multiplo) {
  try {
    const response = await fetch(`${service}/cicleSync`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ multiplo }),
    });
    return await response.json();
  } catch (error) {
    return null;
  }
}

async function getRunMode() {
  try {
    const response = await fetchTO(`${service}/mode`);
    const result = await response.json();
    if (result.status === 404) {
      return defaultRunMode();
    }
    return result;
  } catch {
    return defaultRunMode();
  }
}

function defaultRunMode() {
  return {
    modulo: "MAGAZZINO",
    locale: "---",
    remote: "---",
    versione: "---",
    health: "---",
  };
}

async function creaMovimentiScontrino(
  tipo,
  magazzino,
  causale,
  righe,
  scontrino,
  documento,
  cpc,
) {
  // TODO: verificare come prendere magazzino e causale
  // const infoScontrino = { ...scontrino }
  // delete infoScontrino.righe --> passo anche le righe dello scontrino prchè potrebbe esserci un abbuono sul totale o qualche info sul pagamento
  var data = {
    magazzino,
    tipo,
    causale,
    righe,
    scontrino: scontrino,
    documento: documento,
    cpc: cpc,
  };
  try {
    const response = await fetch(`${service}/movimenti`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    errorService.onError(error, "creaMovimentiScontrino");
  }
}

async function creaMovimenti(movimento) {
  // TODO: Sistemare, probabilemente non funziona
  try {
    const response = await fetch(`${service}/movimenti`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(movimento),
    });
    return await response.json();
  } catch (error) {
    errorService.onError(error, "creaMovimenti");
  }
}

async function getMovimentiParametri(filtro, parametri) {
  try {
    const data = {
      filtro,
      parametri,
    };
    const response = await fetch(`${serviceAnalisi}/movimenti/parametri`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    return error;
  }
}

async function creaMovimentiMultipli(movimentiMultipli, tipo) {
  try {
    const response = await fetch(
      `${service}/movimenti/multipli${tipo ? "?tipo=pc" : ""}`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(movimentiMultipli),
      },
    );
    return await response.json();
  } catch (error) {
    errorService.onError(error, "creaMovimentiMultipli");
  }
}

async function importaInventarioLetture(
  nomeFile,
  tipoFile,
  settore,
  dataLettura,
  note,
  datiRaw,
  dati,
) {
  const data = {
    nomeFile,
    tipoFile,
    settore,
    data: dataLettura,
    note,
    datiRaw,
    dati,
  };
  try {
    const response = await fetch(`${serviceInventario}/importazione/letture`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    });
    return await response.json();
  } catch {}
}

async function creaMovimentoRettificaGiacenza(dati) {
  try {
    const response = await fetch(`${serviceInventario}/giacenza/movimento`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dati),
    });
    return await response.json();
  } catch (error) {
    console.log(error);
    return null;
  }
}

export default {
  cicleSync,
  getRunMode,
  creaMovimentiScontrino,
  creaMovimenti,
  getMovimentiParametri,
  creaMovimentiMultipli,
  importaInventarioLetture,
  creaMovimentoRettificaGiacenza,
};
